import { ModalActionButtons } from "@outschool/ui-legacy-component-library";
import React from "react";

interface EnrollmentModalActionButtonsProps {
  cancelLabel: string;
  onCancel: (event: React.MouseEvent) => void;
  disabled: boolean;
  primaryLabel: string;
  immediatePrimaryAction: (event: MouseEvent) => void;
  trackingName?: string;
  trackingSharedProperties?: Record<string, any>;
}

export default ({
  cancelLabel,
  onCancel,
  disabled,
  primaryLabel,
  immediatePrimaryAction,
  trackingName,
  trackingSharedProperties = {}
}: EnrollmentModalActionButtonsProps) => {
  return (
    <ModalActionButtons
      cancelLabel={cancelLabel}
      onCancel={onCancel}
      disabled={disabled}
      primaryLabel={primaryLabel}
      immediatePrimaryAction={immediatePrimaryAction}
      trackingName={trackingName}
      trackingSharedProperties={trackingSharedProperties}
      sx={{
        marginTop: "1em",
        paddingTop: "1em",
        borderTop: "1px solid",
        borderColor: "gray300",
        justifyContent: "space-between"
      }}
    />
  );
};
